import type * as React from 'react';
import { cn } from '../lib/cn.ts';

export interface TopBarProps {
  /** Left content — typically a page title or breadcrumbs. */
  leading?: React.ReactNode;
  /** Right content — search, notifications, user menu, etc. */
  trailing?: React.ReactNode;
  /** Optional quiet status line below the main top bar area. */
  statusLine?: string;
  className?: string;
  'data-testid'?: string;
}

function TopBar({ leading, trailing, statusLine, className, 'data-testid': testId }: TopBarProps) {
  return (
    <header
      data-testid={testId ?? 'top-bar'}
      className={cn(
        'flex h-14 shrink-0 items-center gap-4 px-6',
        'border-b border-[var(--color-border)]',
        'bg-[var(--color-alabaster)]',
        className,
      )}
    >
      {leading && <div className="flex-1 min-w-0">{leading}</div>}
      {statusLine && (
        <p className="hidden md:block font-[var(--font-mono)] text-xs text-[var(--color-stone-mid)] shrink-0">
          {statusLine}
        </p>
      )}
      {trailing && <div className="flex items-center gap-2 shrink-0">{trailing}</div>}
    </header>
  );
}

export { TopBar };
